/**
 * Since line height is defined in the richEditor css file, its hard to override it from a parent component.
 * To combat this, we swap the line height attribute with a custom attribute, and then we can override it from a parent component.
 */
export const swapLineHeightAttributePreProcessor = (rootNodes, lineHeight) => {
    const processNodes = (nodes: typeof rootNodes) => {
        for (const node of nodes) {
            if (node.type === "tag" && node.name === "p") {
                node.attribs = { ...node.attribs, style: `${node.attribs.style}; line-height: ${lineHeight}` };
            }
            if (node.children) processNodes(node.children);
        }
    };
    processNodes(rootNodes);
};
